import api from '@/utils/api';

/**
 * Get a dealers' supplier single price
 * @param {string} companyId - Query to filter companies
 * @param {string} priceId - The price id
 * @returns {Promise}
 */
const getDealerSupplierPriceApi = (companyId, priceId) =>
  api.get(`dealer/${companyId}/price/${priceId}`);

export default getDealerSupplierPriceApi;
